import { render, staticRenderFns } from "./AddMarketGoodsItem.vue?vue&type=template&id=5141dbb8"
import script from "./AddMarketGoodsItem.vue?vue&type=script&lang=js"
export * from "./AddMarketGoodsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports